import { clearLocalStore } from './local-store';

/**
 * 登出系统
 */
const logout = (router) => {
  // 清除缓存
  clearLocalStore();
  // 进入登录页面
  if (router) {
    router.push('/login');
  }
};

/**
 * 清空store存储
 * @param {*} store
 * @returns
 */
const clearVuexStore = (store) => {
  if (!store) {
    return;
  }
  Object.keys(store.state).forEach((key) => {
    if (typeof store.state[key] === 'object') {
      Object.keys(store.state[key]).forEach((subKey) => {
        store.state[key][subKey] = undefined;
      });
    } else {
      store.state[key] = undefined;
    }
  });
};
export { logout, clearVuexStore };
